/* eslint-disable */
<template>
  <div id="admin-home" v-if="adminPermission && userDataLoaded">
    <AdminSnapshot v-if="activeViewAdmin === 'Snapshot'"></AdminSnapshot>
    <AdminTableContainer v-if="activeViewAdmin != 'Snapshot'"></AdminTableContainer>
  </div>
</template>

<script>
import router from '../../router';
import { mapGetters, mapActions } from 'vuex';
import AdminTableContainer from  '../admin/AdminTableContainer';
import AdminSnapshot from  '../admin/AdminSnapshot';

export default {
  name: 'admin-home',
  components: {
    AdminTableContainer,
    AdminSnapshot
  },
  data() {
    return {
    };
  },
  computed: {
  ...mapGetters( [
    'instructorData',
    'adminPermission',
    'userDataLoaded',
    'activeView'
  ]),
  ...mapGetters('admin', [
    'activeViewAdmin',
    'queryParamsAdmin',
    'snapshotLoaded'
  ]),
  },
  methods:{
  ...mapActions('admin', [

  ]),

  },
  watch: {
    activeViewAdmin: {
      handler: function(val, oldVal) {
        //resets data, updates url, and calls for new data on change to current view or school id
        if( val=== "Schools" || val=== "Instructors" || val === "Bulbs"){
          this.$store.dispatch('admin/getTableData');
        } else if(val=== "Snapshot"){
          if(!this.snapshotLoaded){
            this.$store.dispatch('admin/getSnapshotData');
          }
        }
      }
    },
  },
  created() {

  },
  mounted() {

  },
  updated(){
  }
};
</script>

<style scoped>
#admin-home {
  width: 100%;
  height: 100%;
}
</style>
